// import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { pl } from 'vuetify/locale'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  icons: {
    aliases: {
      expand: 'mdi-arrow-down',
      collapse: 'mdi-arrow-up',
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#eade5e',
        },
      },
    },
  },
  defaults: {
    VBtn: {
      color: 'primary',
      variant: 'outlined',
      rounded: true,
      height: 50,
      size: 'large',
      exact: true,
    },
  },
  locale: {
    locale: 'pl',
    messages: { pl },
  },
})
